module.exports = __webpack_public_path__ + "img/97c44a47f653ff3b2ebad95d391eacb.2a38cc4c.jpg";